<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 id="toc_marker-2" title="Dedication"></h1>
<p class="body"></p>
<p class="body"></p>
<p class="center">To Todd Capen and Jeff Weigum</p>
<p class="center">Thank you for teaching me the faith in love, passion and humility</p>
<p class="center"><em class="i">Kelly</em></p>
<p class="center"> </p>
<p class="center">To my parents, Gaylen and Marla Vander Lugt</p>
<p class="center">For passionately upholding and consistently demonstrating the richness of the Reformed tradition</p>
<p class="center"><em class="i">Wes</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?50b8067e